import PageHeading from "../../../components/desktop/PageHeading";
export default function Dashboard() {
    return (
        <div>
            {/* Your dashboard UI here */}
            <PageHeading>Admin Desktop Dashboard</PageHeading>
        </div>
    );
}